import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { adminKeys } from "@/lib/query-keys";
import type { AdminOrganization } from "@/types/domain";

/** Las empresas con su equipo, sus líneas de negocio y sus desbloqueos. */
export function useAdminOrganizations() {
  return useQuery({
    queryKey: adminKeys.organizations,
    queryFn: () => fetchToBackend<AdminOrganization[]>("/admin/organizations"),
  });
}
